export default __webpack_public_path__ + "static/media/neo4j.9fa59603.png";